<div class="container font-weight-light mt-4" >
<div class="container animate__animated animate__fadeIn">
       <div>
          <img src="./assets/public/images/loading.gif" alt="">
       </div>
    </div>
</div>
